import { ProspectStatus } from "@prisma/client";

export enum ProspectListTab {
  ALL = "all",
  NEW = "new",
  QUALIFIED = "qualified",
  REJECTED = "rejected",
}

export const PROSPECT_LIST_TAB_STATUS: Record<ProspectListTab, ProspectStatus | undefined> = {
  [ProspectListTab.ALL]: undefined,
  [ProspectListTab.NEW]: ProspectStatus.NEW,
  [ProspectListTab.QUALIFIED]: ProspectStatus.QUALIFIED,
  [ProspectListTab.REJECTED]: ProspectStatus.REJECTED,
};
